import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/historico.css';
import api, { asArray } from '../lib/api';

function HistoricoRelatorios() {
  const navigate = useNavigate();
  const [relatorios, setRelatorios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    carregarRelatorios();
  }, []);

  const carregarRelatorios = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/relatorios?limite=50&offset=0');
      setRelatorios(asArray(response.data));
    } catch (err) {
      setError('Erro ao carregar histórico de relatórios');
      console.error('Erro:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewRelatorio = (relatorioId) => {
    navigate(`/resultados/${relatorioId}`);
  };

  const formatarData = (dataStr) => {
    return new Date(dataStr).toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (conformes, nao_conformes, alertas) => {
    if (nao_conformes > 0) return '#f8d7da'; // Vermelho
    if (alertas > 0) return '#fff3cd'; // Amarelo
    return '#d4edda'; // Verde
  };

  if (loading) {
    return <div className="loading">Carregando histórico...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>❌ Erro</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')} className="btn-primary">
          Voltar
        </button>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="historico-container">
        <h1>📜 Histórico de Relatórios</h1>

        {relatorios.length === 0 ? (
          <div className="empty-state">
            <p>Nenhum relatório ainda. Comece com uma nova análise!</p>
            <button onClick={() => navigate('/')} className="btn-primary">
              Criar Primeiro Relatório
            </button>
          </div>
        ) : (
          <div className="relatorios-table">
            <table>
              <thead>
                <tr>
                  <th>Endereço</th>
                  <th>Zona</th>
                  <th>Data</th>
                  <th>Conformes</th>
                  <th>Não Conformes</th>
                  <th>Alertas</th>
                  <th>Status</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {relatorios.map((r) => (
                  <tr key={r.id} style={{ backgroundColor: getStatusColor(r.conformes, r.nao_conformes, r.alertas) }}>
                    <td className="endereco">{r.endereco}</td>
                    <td>{r.zona}</td>
                    <td className="data">{formatarData(r.data_criacao)}</td>
                    <td className="conforme">✅ {r.conformes}</td>
                    <td className="nao-conforme">❌ {r.nao_conformes}</td>
                    <td className="alerta">⚠️ {r.alertas}</td>
                    <td>
                      {r.nao_conformes > 0 ? '❌ Não Conforme' : r.alertas > 0 ? '⚠️ Com Alertas' : '✅ Conforme'}
                    </td>
                    <td>
                      <button
                        onClick={() => handleViewRelatorio(r.id)}
                        className="btn-view"
                      >
                        Visualizar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default HistoricoRelatorios;
